export const CameraProjectionTypes = {
  Orthographic: 0,
  Perspective: 1,
}
